// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"175":"647abc62a94bf938","977":"700a36521b150fcf"}[chunkId] + ".css";
};